import React from 'react';

import epochs from '~/kits/general/config';
import Epoch from '~/kits/general/scripts/Epoch';
import Chart from '~/kits/general/scripts/Chart';
import useActiveItem from './useActiveItem';
import Icon from '~/core/scripts/components/Icon';
import { is768Query } from '~/core/scripts/mediaquery-helper';
import ChartTitle from '~/kits/general/scripts/ChartTitle';

const isSmallScreen = !is768Query();

const Headline = () => (
  <div className="headline">
    <div className="topline">
      {/* <time className="date">01.01.2016</time> */}
      {/* <span className="kicker">SPD im freien Fall</span> */}
    </div>
    <h1 className="title"><strong>SPD im freien Fall –</strong>
      Können Esken und Walter-Borjans den Abwärtstrend noch stoppen?
    </h1>
    <h2 className="introtext">
      Innerhalb von zwei Jahrzehnten ist die SPD in den Umfragen von 46 auf heute unter 15 Prozent gestürzt. 
      Alle SPD-Vorsitzenden seit 1998 - im Vergleich zu den bundesweiten Umfragewerten für die Partei.
    </h2>
  </div>
);

export default () => {
  const activeItemId = useActiveItem();

  if (isSmallScreen) {
    return (
      <div className="scrollapp">
        <Headline />
        <div className="chartheader">
          <ChartTitle />
        </div>
        <Chart activeItemId={activeItemId} />
        <div className="scroller">
          <div className="chronik">
            {epochs.map(epoch => (
              <Epoch key={epoch.id} activeItemId={activeItemId} {...epoch} />
            ))}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="scrollapp">
      <div className="scroller">
        <Headline />
        <div className="chronik">
          {epochs.map(epoch => (
            <Epoch key={epoch.id} activeItemId={activeItemId} {...epoch} />
          ))}
        </div>
      </div>
      <div className="chartcontainer">
        <Chart activeItemId={activeItemId} />
      </div>
    </div>
  );
};
